var exports = {
  "iE": "xa15a2ab7--f0119a--wrapper",
  "wx": "xa15a2ab7--f0119a--header",
  "yJ": "xa15a2ab7--f0119a--links",
};

module.exports = exports;
